<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        class='font-weight-light'
        v-model="search"
        append-icon="mdi-magnify"
        label="Search user"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
   <v-data-table :loading='loading' :search="search" :headers='headers' :items='users' sort-by='firstname' class='elevation-1'>
    <template v-slot:top>
      <v-toolbar flat id='manageTable'>
        <v-toolbar-title class='display-1 fontcolor'>Manage Users</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog default v-model='dialog' max-width='500px' scrollable>
          <template v-slot:activator='{ on }'>
            <v-btn outlined dark class='mb-2 fontcolor' v-on='on' @click="hideEditedFields">
              <v-icon dark>mdi-plus</v-icon>Add New User
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
                <span class='headline fontcolor'>{{ formTitle }}</span>
            </v-card-title>
              <v-card class="pl-7 pr-6 pt-5 pb-5" >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                <v-row>
                  <v-col cols="15" sm="12" md="10" lg="12">
                    <v-text-field
                      v-model='editedItem.firstName'
                      :maxlength='max'
                      :rules='firstNameRules'
                      label='First name*'
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="15" sm="12" md="10" lg="12">
                    <v-text-field
                      v-model='editedItem.lastName'
                      :maxlength='max'
                      :rules='lastNameRules'
                      label='Last name*'
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="15" sm="12" md="10" lg="12">
                    <v-text-field
                      v-model='editedItem.email'
                      :rules='usernameRules'
                      label='Email*'
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!editedFields" cols="15" sm="12" md="10" lg="12">
                    <v-text-field
                      v-model="editedItem.password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="pwdRules"
                      :type="show1 ? 'text' : 'password'"
                      label="Password*"
                      name="password"
                      hint="Password must be 6-14 characters with at least one number and one character. Allowed special characters are !,@,#,$,%,^,&,*,(,),_"
                      required
                      @click:append="show1 = !show1"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="!editedFields" cols="15" sm="12" md="10" lg="12">
                    <v-text-field
                      v-model="editedItem.confirmPassword"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[IsConPwdEmpty,IsMatchWithPass]"
                      :type="show2 ? 'text' : 'password'"
                      label="Confirm Password*"
                      name="confirmPassword"
                      hint="Must be matched with your password"
                      required
                      @click:append="show2 = !show2"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="editedFields && (userId !== editedItem.id)" >
                    <v-select
                      v-model='editedItem.status'
                      :items="statusItems"
                      label="Status*"
                      :rules="statusRules"
                      item-text="statusText"
                      item-value="statusVal"
                    ></v-select>
                  </v-col>
                  <v-col cols="15" sm="12" md="10" lg="12">
                     <v-select
                      v-model='editedItem.company'
                      :items="['ICC', 'ISO', 'FLASH']"
                      label="Company*"
                      :rules="companyRules"
                      required
                      ></v-select>
                  </v-col>
                  <v-col cols="15" sm="12" md="10" lg="12">
                     <v-select
                      v-model='editedItem.role'
                      :items="roleItems"
                      label="Role*"
                      :rules="roleRules"
                      item-text="roleText"
                      item-value="roleVal"
                      :disabled="(userId === editedItem.id)"
                      required
                      ></v-select>
                      <span
                        v-if="editedItem.role === 'ROLE_API_USER'"
                        class="red--text">
                        {{ DISCLAIMER_TEXT_ROLE_API_USER }}
                      </span>
                  </v-col>
                </v-row>
                <!-- Below fields will view only on edit user form.
                    All below fields will be in disable mode.
                -->
                <v-row v-if="editedFields">
                  <v-col>
                    <v-text-field disabled v-model='editedItem.createdBy'
                    label='Created By'></v-text-field>
                  </v-col>
                </v-row>
                <v-row  v-if="editedFields">
                  <v-col>
                    <v-text-field disabled v-model='editedItem.createdDate'
                    label='Created On'></v-text-field>
                  </v-col>
                </v-row>
                <v-row  v-if="editedFields && (editedItem.createdBy !== editedItem.modifiedBy)">
                  <v-col>
                    <v-text-field disabled v-model='editedItem.modifiedBy'
                    label='Modified By'></v-text-field>
                  </v-col>
                </v-row>
                <v-row  v-if="editedFields && (editedItem.createdBy !== editedItem.modifiedBy)" >
                  <v-col>
                    <v-text-field disabled v-model='editedItem.modifiedDate'
                    label='Modified On'></v-text-field>
                  </v-col>
                </v-row>
                <v-card-actions>
                    <small color="primary">*indicates required fields</small>
                  <v-spacer></v-spacer>
                  <v-btn outlined dark color='red' @click='close'>
                    <v-icon dark>mdi-close</v-icon>Cancel
                  </v-btn>
                  <v-btn :loading='btnLoader' outlined class='fontcolor'  @click='save'>
                    <v-icon dark>mdi-check</v-icon>Save
                  </v-btn>
                </v-card-actions>
                </v-form>
              </v-card>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action='{ item }'>
      <v-icon text small class='mr-2' @click='editItem(item)'>mdi-border-color</v-icon>
      <v-icon v-if="item.status == 1" text small class='mr-2' @click='deleteUser(item)'>delete</v-icon>
    </template>
    <template v-slot:no-data>
      <p>{{NO_DATA_FOUND}}</p>
    </template>
  </v-data-table>
  <template>
    <ConfirmationBox  :dialog="deleteDialog" title='Delete Admin User' :discription="dialogDiscription" :cancel="cancel" :confirm="confirmDelete" :btnLoaderConfirm="btnLoaderConfirm" />
    <AlertBox :alertDialog="alertDialog"  :discription="alertDiscription" :cancel="closeAlertBox" />
  </template>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
export default {
  name: 'ManageUser',
  data: () => ({
    show1: false,
    show2: false,
    search: '',
    btnLoader: false,
    loading: true,
    dialog: false,
    edited: false,
    max: 50,
    timeout: 10000,
    successMessage: null,
    deletePopUp: false,
    valid: true,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    DISCLAIMER_TEXT_ROLE_API_USER: CONSTANTS.DISCLAIMER_TEXT_ROLE_API_USER,
    deleteIndex: -1,
    deleteDialog: false,
    alertDialog: false,
    dialogDiscription: '',
    alertDiscription: '',
    btnLoaderConfirm: false,
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'First Name',
        value: 'firstName',
        sortable: true,
        class: 'title'
      },
      { text: 'Last Name', value: 'lastName', sortable: false, class: 'title' },
      { text: 'Status', value: 'statusText', sortable: false, class: 'title' },
      { text: 'Email', value: 'email', sortable: false, class: 'title' },
      { text: 'Company', value: 'company', sortable: false, class: 'title' },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ],
    editedIndex: -1,
    firstNameRules: [v => !!v || 'First name is required.'],
    lastNameRules: [v => !!v || 'Last name is required.'],
    companyRules: [v => !!v || 'Company is required.'],
    roleRules: [v => !!v || 'Role is required.'],
    usernameRules: [
      v => !!v || 'Email is required.',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    pwdRules: [
      v => !!v || 'Password is required.',
      v => /^(?=.*[A-Za-z])(?=.*[0-9])[a-zA-Z0-9!@#_)($%^&*)]{6,14}/.test(v) || 'Invalid Input. Password must be 6-14 characters, Only character (A-Z, a-z), numbers(0-9),special characters(!,@,#,$,%,^,&,*,(,),_) is allowed'
    ],
    statusRules: [v => !!v || 'Status is required.'],
    editedItem: {
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      password: '',
      confirmPassword: '',
      status: '',
      role: ''
    },
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Active', statusVal: 2 }
    ],
    roleItems: [
      {
        roleText: 'Admin', roleVal: 'ROLE_ADMIN'
      },
      {
        roleText: 'API User', roleVal: 'ROLE_API_USER'
      }
    ]
  }),
  components: {
    ConfirmationBox: () => import('./../../locations/modelbox/ConfirmationBox.vue'),
    AlertBox: () => import('./../../locations/modelbox/AlertBox.vue')
  },
  mounted () {
    this.initialize()
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add New User' : 'Edit User'
    },
    success () {
      return this.$store.getters['UserModule/getSuccess']
    },
    users () {
      return this.$store.getters['UserModule/fetchUserList']
    },
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    editedFields () {
      return this.edited
    }
  },
  methods: {
    initialize () {
      new Promise((resolve, reject) => {
        this.$store.dispatch('UserModule/getUserList', { resolve, reject })
      }).then((responseData) => {
        this.loading = false
      }).catch(({ response }) => {
        this.loading = false
      })
    },
    hideEditedFields () {
      this.edited = false
    },
    IsConPwdEmpty (v) {
      if (v !== '') {
        return true
      } else {
        return 'Confirm Password is required.'
      }
    },
    IsMatchWithPass (v) {
      if (v === this.editedItem.password) {
        return true
      } else {
        return 'Invalid Input. Must be matched with your password.'
      }
    },
    editItem (user) {
      this.editedIndex = this.users.indexOf(user)
      this.editedItem = Object.assign({}, user)
      this.edited = true
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.users.indexOf(item)
      this.dialog = false
      this.deletePopUp = true
      this.users.splice(index, 1)
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({})
        this.editedIndex = -1
      }, 300)
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    save () {
      if (this.editedIndex > -1 && this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editData = this.editedItem

        let usrStatus = this.userId !== editData.id ? editData.status : CONSTANTS.ACTIVE_USER_DEFAULT_STATUS
        const editedData = {
          firstName: editData.firstName,
          lastName: editData.lastName,
          username: editData.email,
          company: editData.company,
          role: editData.role,
          userId: this.userId,
          status: usrStatus,
          id: editData.id
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('UserModule/editAdminUser', { resolve, reject, editedData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.close()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
      } else {
        if (this.$refs.form.validate()) {
          this.btnLoader = true
          const formData = {
            firstName: this.editedItem.firstName,
            lastName: this.editedItem.lastName,
            username: this.editedItem.email,
            company: this.editedItem.company,
            password: this.editedItem.password,
            confirmPassword: this.editedItem.confirmPassword,
            role: this.editedItem.role,
            status: CONSTANTS.ACTIVE_USER_DEFAULT_STATUS,
            userId: this.userId
          }
          new Promise((resolve, reject) => {
            this.$store.dispatch('UserModule/addAdminUser', { resolve, reject, formData })
          }).then((responseData) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.close()
          }).catch(response => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
            this.$globalStates.notification.init_notifications = true
          })
        }
      }
    },
    // DELETE User START HERE
    cancel () {
      this.deleteDialog = false
    },
    closeAlertBox () {
      this.alertDialog = false
    },
    deleteUser (item) {
      const formData = {
        userId: this.userId,
        id: item.id,
        isValidation: true
      }
      this.deleteIndex = item.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('UserModule/validateAdminUser', {
          resolve,
          reject,
          formData
        })
      })
        .then(responseData => {
          this.deleteDialog = true
          this.dialogDiscription = `'` + item.firstName + `' User`
        })
        .catch(response => {
          this.alertDialog = true
          let message = `A few reference(s) exist in other Entity(s), please remove all references and try again to delete '` + item.firstName + `' User.`
          this.alertDiscription = message
        })
    },
    confirmDelete () {
      this.btnLoader = true
      const formData = { userId: this.userId, id: this.deleteIndex }
      let isPromise = new Promise((resolve, reject) => {
        this.$store.dispatch('UserModule/deleteAdminUser', { resolve, reject, formData })
      })
      isPromise
        .then((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
        .catch((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
    }
  }
}
</script>
<style scoped>

</style>
